import { SocialLinksCommonInterface } from '@systemeio/digital-store-shared'

export const editSocialLinksArr = (
  socialLinks: Array<SocialLinksCommonInterface>,
  newSocialLink: SocialLinksCommonInterface,
): Array<SocialLinksCommonInterface> => {
  const newSocialLinks = [...socialLinks]

  const isSocialLinkEmpty = !newSocialLink.url
  if (isSocialLinkEmpty) {
    return newSocialLinks.filter(socialLink => socialLink.type !== newSocialLink.type)
  }

  let isChanged = false

  newSocialLinks.forEach(link => {
    if (link.type === newSocialLink.type) {
      link.url = newSocialLink.url
      isChanged = true
    }
  })

  if (!isChanged) {
    newSocialLinks.push(newSocialLink)
  }

  return newSocialLinks
}
